/* istanbul ignore file */
import { Logger } from 'core/common/services/logger/interfaces';
import { useServices } from './useServices';

export function useLogger(): Logger {
  const { loggingService } = useServices();

  return loggingService;
}
